<template>
  <div class="saleoutView">
    <vxe-layout-container vertical>
      <vxe-layout-header>
        <div
          style="display: flex; justify-content: flex-start; align-items: center;margin:10px">
          <vxe-button status="primary" icon="vxe-icon-save" @click="handleSave" >保存</vxe-button>
          <vxe-button status="primary" icon="vxe-icon-search" @click="handlePriceQuery" >销价查询</vxe-button>
          <vxe-button status="primary" icon="vxe-icon-print" :options="downBtns" @dropdown-click="dropdownClickEvent">打印单据</vxe-button>
          <vxe-button status="primary" icon="vxe-icon-delete" @click="handleDeleteRow" >删除行</vxe-button>
        </div>
        <div>
          <vxe-form ref="formRef" :data="formData" :rules="formRules" title-align="right" title-width="80px">
            <!-- 单号 -->
            <vxe-form-item title="单号" field="ckdh" :span="4">
              <template #default>
                <vxe-input v-model="formData.ckdh" placeholder="请输入单号"  class="form-input" :editable="false"/>
              </template>
            </vxe-form-item>

            <!-- 日期 -->
            <vxe-form-item title="日期" field="rq" :span="4">
              <template #default>
                <vxe-date-picker v-model="formData.rq" placeholder="请选择日期"  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" class="form-input" />
              </template>
            </vxe-form-item>

            <!-- 开单人 -->
            <vxe-form-item title="开单人" field="jsrbh" :span="3">
              <template #default>
                <vxe-input v-model="formData.jsrbh" placeholder="请输入开单人"  class="form-input" />
              </template>
            </vxe-form-item>

            <!-- 客户名称 -->
            <vxe-form-item title="客户名称" field="khmc" :span="6">
              <template #default>
                <vxe-input v-model="formData.khmc" type="search" placeholder="请输入客户名称" clearable @search-click="handleShowSearchCustomer"
  @keyup.enter="handleShowSearchCustomer"
                  class="form-input" />
              </template>
            </vxe-form-item>

            <!-- 发货仓库 -->
            <vxe-form-item title="发货仓库" field="ckbh" :span="6">
              <template #default>
                <vxe-input v-model="formData.ckbh" placeholder="请输入发货仓库"  class="form-input" />
              </template>
            </vxe-form-item>

            <!-- 发货公司 -->
            <vxe-form-item title="发货公司" field="qsr" :span="8">
              <template #default>
                <vxe-select v-model="formData.qsr" placeholder="请输入发货公司">
                  <vxe-option key="1" value="科创电脑" label="科创电脑"></vxe-option>
                  <vxe-option key="2" value="华慧电脑" label="华慧电脑"></vxe-option>
                  <vxe-option key="3" value="苏宜电子" label="苏宜电子"></vxe-option>
                </vxe-select>

              </template>
            </vxe-form-item>

            <!-- 含税 -->
            <vxe-form-item title="含税" field="hs" :span="3">
              <template #default>
                <vxe-select v-model="formData.hs" placeholder="请选择"  class="form-input">
                  <vxe-option value="未税" label="未税" />
                  <vxe-option value="含税" label="含税" />
                  <vxe-option value="增值税" label="增值税" />
                </vxe-select>
              </template>
            </vxe-form-item>

            <!-- 备注 -->
            <vxe-form-item title="备注" field="bz" :span="17">
              <template #default>
                <vxe-input v-model="formData.bz" placeholder="请输入备注信息" clearable class="form-input" />
              </template>
            </vxe-form-item>
          </vxe-form>
        </div>
      </vxe-layout-header>

      <vxe-layout-body>

        <vxe-table border show-footer ref="tableref" height="100%" :data="tableData" :footer-data="footerData" :row-config="{ isCurrent: true, isHover: true }"
          @current-change="handleCurrentChange" :edit-config="{ trigger: 'click', mode: 'row' }" @cell-click="handleCurrentChange"
          :cell-config="{ height: 30 }">
          <vxe-column field="seq" type="seq" width="70"></vxe-column>
          <vxe-column field="spbh" title="商品编号" :edit-render="{ name: 'input' }">
            <template #edit="{ row, rowIndex }">
              <vxe-input v-model="row.spbh" type="search" @search-click="ShowselectProductDialog(row, rowIndex)" 
                @keydown.enter="ShowselectProductDialog(row, rowIndex)"></vxe-input>
            </template>
          </vxe-column>
          <vxe-column field="fullname" title="全称"></vxe-column>
          <vxe-column field="unit" title="单位" width="70"></vxe-column>
          <vxe-column field="num" title="数量" show-overflow width="70" :edit-render="{ name: 'input' }">
            <template #edit="{ row }">
              <vxe-input v-model="row.num" @change="updateFootEvent"></vxe-input>
            </template>
          </vxe-column>
          <vxe-column field="price" title="单价" show-overflow width="70" :edit-render="{ name: 'input' }">
            <template #edit="{ row }">
              <vxe-input v-model="row.price" @change="updateFootEvent"></vxe-input>
            </template>
          </vxe-column>
          <vxe-column field="total" title="小计" show-overflow width="100">
            <template #default="{ row }">
              <span>￥{{ sumRowNum(row) }}</span>
            </template>
          </vxe-column>
          <vxe-column field="remarker" title="备注" show-overflow :edit-render="{ name: 'input' }"></vxe-column>

        </vxe-table>

      </vxe-layout-body>
    </vxe-layout-container>
    <!-- 选择商品* -->
    <vxe-modal v-model="showSelectproduct" width="60vw" height="60vh" destroy-on-close title="选择商品">
      <template #default>
        <selectProduct @select="handleSelectProduct" @cancel="showSelectproduct = false" :MnemonicPhraseProp="MnemonicPhrase">
        </selectProduct>
      </template>
    </vxe-modal>
    <!-- 选择客户* -->
    <vxe-modal v-model="showSelectCustomer" width="60vw" height="60vh" destroy-on-close title="客户选择">
      <template #default>
        <selectCustomer @select="handleSelectCustomer" @cancel="showSelectCustomer = false" :MnemonicPhraseProp="formData.khmc">
        </selectCustomer>
      </template>
    </vxe-modal>
     <!-- 进出记录* -->
    <vxe-modal v-model="showInAndOut" width="50vw" height="60vh" destroy-on-close title="进出记录">
      <template #default>
        <stockInOutRecords :Product="product">
        </stockInOutRecords>
      </template>
    </vxe-modal>
  </div>
</template>
<script setup>
import { reactive, defineProps, ref, onMounted } from 'vue'
import { sumRowNum, sumNum } from '../utils/calculate'
import selectProduct from '../components/selectComp/selectproductComp.vue'
import selectCustomer from '../components/selectComp/selectCustomerComp.vue'
import { CreateNewDocument, SaveDocument, GetDocDetail, GetOneDoc ,SaveEditDocument} from '../utils/saleDocHelper'
import stockInOutRecords from '../components/stockInOutRecords.vue'
import request from '../request/request'
import PrintHelper from '../utils/PrintHelper'
import { VxeUI } from 'vxe-pc-ui'
const showSelectproduct = ref(false)
const showSelectCustomer = ref(false)
const tableref = ref(null)
const rowindex = ref(0)
const usefule = ref('')
const product = ref('')
const showInAndOut = ref(false)
const downBtns = ref([
  { name: '1', content: '打印编辑' },
  { name: '2', content: '打印预览' },
  { name: '3', content: '直接打印' }
])
const dropdownClickEvent = (params) => {
  handlePrint(params.option.content)
}
// 搜索客户（打开弹窗并传递关键词）
const handleShowSearchCustomer = () => {
  // 如果有输入内容，可以将其作为搜索关键词传递给弹窗
  // 这里通过修改弹窗的 props 或触发事件来实现
  showSelectCustomer.value = true
}

const handleCurrentChange = (row, index) => {
 product.value = row.row.spbh
  rowindex.value = index
}
// 在值发生改变时更新表尾合计
const updateFootEvent = () => {
  const $table = tableref.value
  if ($table) {
    const fullData = $table.getFullData()
    updateFootCount(fullData)
  }
}
const updateFootCount = (list) => {
  const [sumNObj] = footerData.value
  sumNObj.num = sumNum(list, 'num')
  let count = 0
  list.forEach((item) => {
    count += sumRowNum(item)
  })
  sumNObj.total = count.toFixed(2)
}

// ==================== Props ====================
const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ usefule: '新增', docNumber: '' })
  },

})

// ✅ 直接使用 props.initialData

// ==================== 表单数据 ====================
const formData = reactive({
  ckdh: props.initialData?.docNumber || 'XSDH2026823161839',
  rq:  new Date(),
  jsrbh:  '许耀慧',
  khbh: '',
  ckbh: '东港店',
  qsr:  '科创电脑',
  hs:  '未税',
  bz:  '',
  isDuizhang: false,
  hjje: 0,
  yhje: 0,
  bcsk: 0,
  syje: 0,
  zt: '未审核',
  khmc: ''
})

// ==================== 表单验证规则 ====================
const formRules = reactive({
  ckdh: [{ required: true, message: '单号不能为空' }],
  rq: [{ required: true, message: '请选择日期' }],
  jsrbh: [{ required: true, message: '开单人不能为空' }],
  Customer: [{ required: true, message: '客户不能为空' }],
  qsr: [{ required: true, message: '请选择发货抬头' }],
  hs: [{ required: true, message: '请选择税种' }],
})
const tableData = ref([
])
const InitialData = (length) => { 
  for(let i = 0; i < length; i++)
   {
    tableData.value.push({
      spbh: '',
      fullname: '',
      unit: '',
      num: 0,
      price: 0,
      total: 0,
      remark: ''
    })
   }
  
}
onMounted(async () => {
  usefule.value = props.initialData.usefule
  if (usefule.value === '新增') {
    
    InitialData(20)
  }
  else {
      let res = await GetDocDetail(props.initialData.docNumber)
    if (res.length > 0) {
      res.forEach(item => {
        tableData.value.push({
          spbh: item.spbh,
          fullname: item.sP_QM,
          unit: item.sP_DW,
          num: item.sl,
          price: item.dj,
          total: item.hj,
          remark: item.bz
        })
      })
    }
     let doc=await GetOneDoc(props.initialData.docNumber)
    InitialData(20-tableData.value.length)
    Object.assign(formData,doc)
    formData.khmc=doc.khmc
  }
})
// 表格数据
// const tableData = ref([{
//   productCode: '',
//   productName: '',
//   unit: '',
//   quantity: 0,
//   price: 0,
//   total: 0,
//   remark: ''
// }])
const editConfig = ref({
  trigger: 'click',
  mode: 'cell'
})
const MnemonicPhrase=ref('')
const ShowselectProductDialog = (row,rowIndex) => {

  MnemonicPhrase.value=row.spbh
  showSelectproduct.value = true
  rowindex.value = rowIndex
}
function handlePriceQuery() {
      showInAndOut.value=true
}
const handleSelectCustomer = (data) => {
  try {
    if (data) {
      formData.khbh = data.bh
      formData.khmc = data.khmc
      showSelectCustomer.value = false
    }
  }
  catch (e) {
    alert(e)
  }
}
const handleSelectProduct =async (data) => {
  try {
    const $table = tableref.value
    let index = rowindex.value
    // 如果 data 是数组，取第一个
    const selected = Array.isArray(data) ? data[0] : data

    if (!selected) return
    data.forEach(async (item) => {
      const row = tableData.value[index]
     let resdj= await request.post('Product/GetLastPrice',  { CustomerName: formData.khbh, ProductName: item.sP_BH } )
      if (row) {
        row.spbh = item.sP_BH || ''
        row.fullname = item.sP_QM || ''
        row.unit = item.sP_DW || ''
        row.num = 1
        row.price = resdj.data|| 0
        row.total = row.num * row.price
        row.remarker = ''
        index += 1
      }
    })

    showSelectproduct.value = false
  }
  catch (e) {
    alert(e)
  }

}
const handlePrint=async(useful) =>{
  PrintHelper({doc:formData,details:tableData.value,report:'销售单',useful:useful})
}

function handleDeleteRow() {
  if (!safeTableData.value || safeTableData.value.length === 0) return

  const $table = tableRef.value
  if ($table) {
    const currRow = $table.getCurrentRow()
    if (currRow) {
      const index = tableData.value.indexOf(currRow)
      if (index > -1) {
        tableData.value.splice(index, 1)
        if (tableData.value.length === 0) {
          tableData.value.push(getDefaultRow())
        }

        return
      }
    }
  }

  if (tableData.value.length > 1) {
    const row = tableData.value.pop()

  } else {
    const row = tableData.value[0]
    Object.assign(row, getDefaultRow())
  }
}


const handleSave = async () => {
  if (usefule.value === '新增') {
    await SaveDocument(formData, tableData.value)

  }
  else {
    await SaveEditDocument(formData, tableData.value)
    usefule.value = '新增'
  }
  Object.assign(formData,{
    ckdh: CreateNewDocument('XSDH'),
    rq: new Date(),
    jsrbh: '许耀慧',
    khbh: '',
    ckbh: '东港店',
    qsr: '科创电脑',
    hs: '未税',
    bz: '',
    isDuizhang: false,
    hjje: 0,
    yhje: 0,
    bcsk: 0,
    syje: 0,
    zt: '未审核',
    khmc: ''
  } )
  tableData.value = []
  InitialData(20)
  VxeUI.modal.message({
    id: 'myUniqueMsg',
    content: '保存成功',
    status: 'success'
  })



}
const footerData = ref([{ seq: '合计', num: '0', total: '0' }])
</script>
<style scoped>
.saleoutView {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  flex: 1;
  min-height: 0;
  margin-top: 10px;
}
</style>